import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import CONFIG from "../config";

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private config: any;

    constructor(private http: HttpClient) {
        this.config = JSON.parse(JSON.stringify(CONFIG));
    }

    public get(name: string): any {
        try {
            const portions: string[] = name.split(".");
            let o: any = this.config;
            while (portions.length > 1 && typeof o === "object") {
                o = o[portions.shift()];
            }

            return o[portions[0]];
        } catch(e) {
            console.error("no such key", name, e);
            return undefined;
        }
    }

    public load(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(this.get("api.url") + "/config").subscribe(
                data => {
                    this.config = Object.assign(this.config, { server: data});
                    console.info("config", this.config);
                    resolve(data);
                },
                err => {
                    console.error("Error fetching config", err);
                    reject(err);
                },
            );
        });
    }
}
